import React from "react";
import { LiveDataQualityStatus } from "../../LiveDataQualityCircle";
import { useNavigate } from "react-router-dom";

const AssetListCard = ({ asset, cardClicked, teamConfig }) => {
  const navigate = useNavigate();

  const getPropertyData = (fp) => {
    const data = asset?.properties.find((p) => p.id === fp.fieldId);
    return data;
  };

  return (
    <div
      className={`${
        asset.cardClicked && asset.cardClicked === true
          ? "border-white"
          : asset.latestAlarm?.status === "warning"
          ? "border-orange-700"
          : asset.latestAlarm?.status === "critical"
          ? "border-red-700 "
          : "border-blue-700"
      }
         ${
           asset.latestAlarm
             ? asset.latestAlarm?.status === "warning"
               ? "from-orange-700 to-zinc-900"
               : asset.latestAlarm?.status === "critical" &&
                 "from-red-700 to-zinc-900"
             : "hover:border-blue-700 from-blue-700 to-zinc-900"
         } parent flex-col h-fit w-full rounded-lg bg-gradient-to-b mb-2 border-2 hover:border-white`}
      key={asset.id}
      onClick={() => cardClicked(asset)}
    >
      <div className="flex justify-between px-4 py-2">
        <div className="flex gap-2 items-center">
          <label className="font-semibold text-xs text-white ">
            {asset.name}
          </label>
          {asset?.devices.map((x, index) => {
            return (
              <LiveDataQualityStatus
                timeStamp={asset?.timeStamp}
                enabled={true}
                interval={x?.device.interval}
                parameterName={x?.device.name}
                renderType={"monitor"}
                key={index}
              />
            );
          })}
        </div>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={(e, id) => {
              navigate(`/details/asset/${asset.id}`);
            }}
            className={`${
              (asset.cardClicked && asset.cardClicked === true) ||
              asset.latestAlarm !== ""
                ? "text-white border-white"
                : " text-white border-white"
            }  w-fit font-medium text-xxs flex justify-center items-center`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-4"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
              />
            </svg>
          </button>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-y-2 auto-cols-fr px-4 pt-1 pb-3">
        {teamConfig &&
          teamConfig
            ?.sort((a, b) => a.orderIndex - b.orderIndex)
            .filter((x) => x.fieldType === "property" && x.value !== null)
            .slice(0, 3)
            .map((fp, index) => {
              const propertiesValue = getPropertyData(fp);
              return (
                <div className="flex items-center w-full" key={index}>
                  <div
                    className={`${
                      index === 0 || index === 3 ? "" : "border-l pl-3"
                    } flex-col w-min border-zinc-700`}
                  >
                    <div className="text-zinc-400 font-semibold text-xs overflow-hidden truncate text-ellipsis max-w-[100px]">
                      <label className="">{propertiesValue?.value}</label>
                    </div>
                    <div className="text-neutral-500 font-medium text-xxs truncate max-w-[90px]">
                      <label>{propertiesValue?.key}</label>
                    </div>
                  </div>
                </div>
              );
            })}
      </div>
    </div>
  );
};

export default AssetListCard;
